<template>
  <div class="sleepTestTop" v-cloak>
    <v-container class="sleepMovie_container">
      <v-row
        v-for="n in 1"
        :key="n"
        :class="n === 1 ? 'mb-6' : ''"
        class="sleepTestTop_cont"
      >
        <v-col lg="12" md="12" sm="12" cols="12">
          <span class="sleepTestTop_title">睡眠知識動画</span>
          <p class="sleepTestTop_subTitle">
            1本あたり約20分の睡眠セミナーの動画です。<br />普段はあまり意識しない質の高い睡眠について本動画で正しい知識を身につけましょう。
          </p>
        </v-col>
        <v-col
          lg="4"
          md="4"
          sm="4"
          cols="12"
          v-for="(item, index) in contents.sleepMovies"
          :key="item.id"
        >
          <v-card
            class="sleepTestTop_main"
            :img="item.imageUrl"
            v-on:click="toDetailPath('main', index)"
          >
            <p class="sleepTestTop_sleepMainDesc">
              <span class="sleepTestTop_descTitleLine">{{ item.title }}</span>
              <span
                v-html="item.description"
                class="sleepTestTop_descLine"
              ></span>
            </p>
          </v-card>
        </v-col>
        <v-col lg="12" md="12" sm="12" cols="12">
          <v-spacer />
          <span class="sleepTestTop_title">睡眠サポート動画</span>
          <p class="sleepTestTop_subTitle">
            1本あたり10～20分程度の睡眠を改善するためのセミナー動画です。<br />日々の生活で手軽に試せるのでぜひ取り入れてみてください。
          </p>
        </v-col>
        <v-col
          lg="4"
          md="6"
          sm="6"
          cols="12"
          v-for="(item, index) in contents.otherMovies"
          :key="item.id"
        >
          <v-card
            class="sleepTestTop_sub"
            v-on:click="toDetailPath('other', index)"
          >
            <v-img class="sleepTestTop_subImg" :src="item.imageUrl"></v-img>
            <p class="sleepTestTop_sleepSubDesc">
              <span class="sleepTestTop_descSupportTitleLine">{{
                item.title
              }}</span>
              <span class="sleepTestTop_descSubLine">{{
                item.description
              }}</span>
            </p>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import axios from "axios";
/* eslint-disable */
export default {
  data: function() {
    return {
      contents: {},
    };
  },
  methods: {
    toDetailPath(category, index) {
      if (category == "main") {
        this.$store.commit(
          "setValueToSleepTest",
          this.contents.sleepMovies[index]
        );
      } else {
        this.$store.commit(
          "setValueToSleepTest",
          this.contents.otherMovies[index]
        );
      }
      this.$router.push("/sleepTestDetail");
      window.scrollTo(0, 0);
    },
  },
  created() {
    // 遷移時にコンテンツを取得する
    axios
      .get("/sleepmovie/content", {
        params: { userName: this.getLoginUserId },
        headers: { Authorization: this.getAccessToken },
      })
      .then(
        function(response) {
          this.contents = response.data;
        }.bind(this)
      )
      .catch((error) => {
        this.error = error;
      });
  },
  computed: {
    ...mapGetters(["getLoginState", "getLoginUserId", "getAccessToken"]),
  },
};
</script>
<style lang="scss" scoped>
$xs: "320px";
$sm: "480px";
$md: "800px";
// .sleepMovie_container {
//   min-width: 95%;
// }
.sleepTestTop {
  background: #5592c6;
  min-height: calc(100vh - 96px);
  &_logo {
    width: 160px;
  }
  &_menuTtl {
    padding-left: 50px;
    padding-right: 50px;
  }
  &_sleepMainDesc {
    position: absolute;
    bottom: 0;
    // margin-top: 16px;
    font-weight: 600;
    padding-right: 1em;
    letter-spacing: 0.04em;
    // color: #1d64a1;
    color: #ffff;
    line-height: 1.6;
    text-align: right;
    text-shadow: 1px 2px 3px rgba(46, 44, 44, 0.973);
    @media screen and (max-width: $md) {
      font-size: 14px;
      margin-left: 4px;
    }
  }
  &_sleepSubDesc {
    position: absolute;
    bottom: 0;
    // margin-top: 16px;
    font-weight: 600;
    padding-right: 1em;
    margin-left: 0%;
    letter-spacing: 0.04em;
    color: #1d64a1;
    line-height: 1.6;
    text-align: right;
    @media screen and (max-width: 1265px) {
      // margin-left: %;
      font-size: 14px;
    }
    @media screen and (max-width: 960px) {
      // margin-left: 43%;
      font-size: 14px;
    }
    @media screen and (max-width: $sm) {
      // margin-left: 0%;
      font-size: 14px;
    }
  }
  &_descTitleLine {
    font-size: 22px;
    display: inline-block;
    // pc
    @media screen and (max-width: 1264px) {
      font-size: 18px;
    }
    @media screen and (max-width: 960px) {
      font-size: 18px;
    }
    // sp
    @media screen and (max-width: 600px) {
      font-size: 24px;
    }
    @media screen and (max-width: $sm) {
      font-size: 20px;
    }
  }
  &_descSupportTitleLine {
    font-size: 20px;
    display: inline-block;
  }
  &_descLine {
    font-size: 14px;
    display: inline-block;
    // pc
    @media screen and (max-width: 1264px) {
      font-size: 12px;
    }
    @media screen and (max-width: 960px) {
      font-size: 10px;
    }
    // sp
    @media screen and (max-width: 600px) {
      font-size: 16px;
    }
    @media screen and (max-width: $sm) {
      font-size: 12px;
    }
  }
  &_descSubLine {
    font-size: 16px;
    color: #292828;
    display: inline-block;
    @media screen and (max-width: $sm) {
      font-size: 15px;
    }
  }
  &_title {
    font-size: 28px;
    color: #ffff;
    font-weight: bold;
    @media screen and (max-width: $md) {
      font-size: 24px;
    }
  }
  &_subTitle {
    font-size: 18px;
    // font-weight: bold;
    color: #ffff;
    margin-bottom: 0px;
    @media screen and (max-width: $md) {
      font-size: 16px;
    }
  }
  &_cont {
    padding: 1.2em;
    background: rgba(0, 0, 32, 0.2);
    border-radius: 6px;
    margin: 0 auto !important;
    max-width: 1280px;
    @media screen and (max-width: $md) {
      padding: 16px;
    }
  }
  &_main {
    background: #fff center right no-repeat;
    background-size: auto 50%;
    padding: 0.8em;
    height: 20em;
    @media screen and (max-width: 1264px) {
      padding: 0.5em;
      background-size: auto 50%;
      height: 15em;
    }
    @media screen and (max-width: 414px) {
      height: 13em;
    }
  }
  &_sub {
    background: #fff center right no-repeat;
    background-size: auto 50%;
    padding: 1em;
    height: 8.5em;
    @media screen and (min-width: 1264px) {
      padding: 0.5em;
      background-size: auto 50%;
      height: 10em;
    }
  }
  &_subImg {
    max-width: 30%;
    @media screen and (max-width: 960px) {
      max-width: 24%;
    }
    @media screen and (max-width: 600px) {
      max-width: 25%;
    }
    @media screen and (max-width: $sm) {
      max-width: 20%;
    }
  }
  &_card {
    padding: 48px;
    @media screen and (max-width: $md) {
      padding: 16px;
    }
    p {
      margin: 0;
    }
  }
  &_card-disabled {
    opacity: 0.7;
  }
  &_cardTtl {
    text-align: center;
    font-size: 24px;
    color: #5592c6;
    font-weight: bold;
    @media screen and (max-width: $md) {
      font-size: 20px;
    }
  }
  &_desc {
    font-size: 15px;
    margin-top: 8px !important;
    @media screen and (max-width: $md) {
      font-size: 13px;
      margin-top: 0 !important;
    }
  }
}
.cards {
  margin-top: 100px;
  color: #fff;
  background: rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  padding: 48px;
}

[v-cloak] {
  display: none;
}
.spacer {
  height: 1em;
}
</style>
<style>
.br_candidate {
  display: inline-block;
}
</style>